import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../../common/models';
import { FailedMessagesReportFieldModel } from '../../models/profile/failed-messages-profile-report.model';
import {
  FailedMessagesProfileReportLoad,
  FailedMessagesProfileReportInitialState,
} from './failed-messages-profile-report.actions';
import { FailedMessagesProfileReportState } from './failed-messages-profile-report.state';

@Injectable({ providedIn: 'root' })
export class FailedMessagesProfileReportFacade implements LoadDataFacade, SetInitialStateFacade {
  reportFields$: Observable<FailedMessagesReportFieldModel[]> = this.store.select(
    FailedMessagesProfileReportState.getReportFields,
  );
  loaded$: Observable<boolean> = this.store.select(FailedMessagesProfileReportState.getLoaded);

  constructor(private store: Store) {}

  loadAll(): void {
    this.store.dispatch(new FailedMessagesProfileReportLoad());
  }

  setInitialState(): void {
    this.store.dispatch(new FailedMessagesProfileReportInitialState());
  }
}
